import React from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
const Radio = ({ onClick, isError, isSelected, isDisabled, withLabel, id, name }) => {
    const classNames = classnames({
        [styles.radio]: true,
        [styles.error]: isError,
        [styles.selected]: isSelected
    });
    return (React.createElement("div", { className: `${styles.radioWrap} ${withLabel ? styles.noPointer : ''}` },
        React.createElement("input", { name: name, value: id, tabIndex: withLabel ? -1 : 0, className: classNames, onClick: (e) => onClick(e, id), type: 'button', "aria-label": `radio is ${(isError && 'error') || (isSelected && 'selected')}`, disabled: !withLabel && isDisabled }),
        isSelected && React.createElement("i", { className: styles.icon })));
};
export default Radio;
